export function uploadFile(url, file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onloadend = (e) => {
			const arrayBuffer = e.target.result;
			uploadTo(url, arrayBuffer)
				.then(resolve) // 上传成功，返回结果
				.catch(reject); // 上传失败，抛出错误
		};

		reader.onerror = () => {
			reject(new Error('文件读取失败'));
		};

		reader.readAsArrayBuffer(file);
	});
}

function uploadTo(url, arrayBuffer) {
	return new Promise((resolve, reject) => {
		fetch(url, {
				method: "PUT",
				body: arrayBuffer,
				headers: {
					"Content-Type": "application/octet-stream",
				},
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`上传失败: ${response.status}`);
				}
				return response;
			})
			.then(() => {
				// 上传成功
				resolve("上传成功");
			})
			.catch((error) => {
				console.error('上传失败:', error);
				reject(error);
			});
	});
}